import React from 'react';
import { AchievementResponse } from '../features/gamification/types';

const ACHIEVEMENT_DEFAULT_IMAGE = "/assets/img/kiste.png";
export const AchievementCard = (props: { achievement: AchievementResponse }) => {
  const { name, description } = props.achievement;

  const imgSrc = ACHIEVEMENT_DEFAULT_IMAGE;
  return (
    <div className="col col-sm-6 col-md-3 col-lg-2 mb-4 project-card" title={description}>
      <div className="card text-center h-100 no-border project-card-content">
        <img src={imgSrc} className="card-img-top project-image" alt="Projekt" />
        <div className="card-body">
          <p className="card-title project-name">{name}</p>
        </div>  
      </div>
    </div>
  );
}
